 

const custom_text = {
    field_type: 'input',
    key: 'text',
    element: {
        placeholder: '123-456-7890',
        label: 'Enter your phone number',
    },
}

const buttonset = {
    field_type: 'buttonset',
    buttons: [
        {
            type: 'submit',
            label: 'Save',
            loading_label: 'Saving…',
            className: 'button fullwidth dark primary xlarge',
        },
    ],
}

const call_me = {
    id: 'call_me',
    label: 'Call me',
    glyph: 'phone',
    fields: [custom_text, buttonset],
    is_premium: false,
    mechanism: 'call',
    group: 'call',
}

module.exports = call_me
